import React from 'react';
import { SIcon } from '@avalara/skylab-sdk/react';
import ExternalLink from '../external-link';
import { Info } from '../styled/skylab/box';
import { CheckedUL } from '../styled/components/sign-up';
import ThirdBulletContent from './third-bullet';
const CheckoutPurchaseInfo = ({ isDirectToBuy = false, partnerSignup, start, showThirdBullet }) => (React.createElement(React.Fragment, null,
    React.createElement("div", null,
        React.createElement(Info, null, !start ?
            React.createElement(React.Fragment, null,
                React.createElement("p", { "data-ref": 'buy.signup.start.info-content' },
                    'We\'ll',
                    " set up your first company.",
                    React.createElement("br", null),
                    "You can add additional companies later."),
                React.createElement("p", null,
                    'We\'ll',
                    " use your business address to set up default tax calculation in AvaTax."),
                React.createElement("p", null, "You can make changes and add additional jurisdictions later.")) :
            React.createElement(React.Fragment, null,
                React.createElement("h3", { "data-ref": 'buy.signup.start.header', className: 'alt text-center text-md' }, 'What\'s included?'),
                React.createElement(CheckedUL, null,
                    React.createElement("li", { "data-ref": 'buy.signup.list-item-one' },
                        React.createElement(SIcon, { name: 'check' }),
                        "Full access to AvaTax"),
                    React.createElement("li", { "data-ref": 'buy.signup.list-item-two' },
                        React.createElement(SIcon, { name: 'check' }),
                        "API use and data import ability"),
                    window.location.href.indexOf('partner') === -1 &&
                        React.createElement("li", { "data-ref": 'buy.signup.list-item-partner' },
                            React.createElement(SIcon, { name: 'check' }),
                            "Limited number of connectors"),
                    !isDirectToBuy && showThirdBullet &&
                        React.createElement("li", { "data-ref": 'buy.signup.list-item-third' },
                            React.createElement(SIcon, { name: 'check' }),
                            React.createElement(ThirdBulletContent, { partnerSignup: partnerSignup }))))),
        !isDirectToBuy && React.createElement("div", { className: 'margin-top-lg pad-left-lg', style: { color: 'initial' } },
            React.createElement("p", null, "Have questions about the AvaTax free trial?"),
            React.createElement("p", null,
                "Check out\u00A0",
                React.createElement(ExternalLink, { "data-ref": 'buy.signup.faq.link', href: 'https://help.avalara.com/Frequently_Asked_Questions/Avalara_AvaTax_Update_FAQ/Avalara_AvaTax_Free_Trial_Frequently_Asked_Questions', alwaysOpenInNewTab: true }, "our FAQs.")))),
    React.createElement("div", null)));
export default CheckoutPurchaseInfo;
